(function(){
'use strict';

if (document.readyState !== 'loading') { initOrSkip(); }
else { document.addEventListener('DOMContentLoaded', initOrSkip); }

function initOrSkip() {
  /* Shopify theme editor: skip entirely. */
  if ((window.Shopify && window.Shopify.designMode) ||
      document.documentElement.classList.contains('shopify-design-mode')) {
    killPreloader(); setupHeader(); return;
  }
  /* Non-home pages: no preloader, just set up sticky behaviour. */
  if (!document.body.classList.contains('template-index')) {
    killPreloader(); setupHeader(); return;
  }
  init();
}

function killPreloader() {
  document.body.classList.remove('c9-loading');
  var el = document.getElementById('c9-preloader');
  if (el) el.style.display = 'none';
}

function setupHeader() {
  if (!document.body.classList.contains('template-index')) return;
  var hw     = document.querySelector('.header-wrapper');
  var sticky = document.getElementById('c9-sticky');
  if (!hw) return;

  hw.style.transition = 'opacity 0.8s ease, background 0.35s ease, backdrop-filter 0.35s ease, box-shadow 0.35s ease';
  requestAnimationFrame(function() {
    requestAnimationFrame(function() { hw.style.opacity = '1'; });
  });

  function getHeroImgH() {
    var imgBlock = document.querySelector('.c9h2__img-block');
    if (imgBlock) return imgBlock.getBoundingClientRect().height;
    var heroEl = document.querySelector('.c9-hero');
    if (heroEl) return heroEl.getBoundingClientRect().height;
    return window.innerHeight;
  }

  function update() {
    var sy      = window.scrollY;
    var heroH   = getHeroImgH();
    var pastImg = sy >= heroH - 10;

    if (!pastImg) {
      hw.style.removeProperty('pointer-events');
      hw.classList.remove('c9-hidden');
      if (hw.style.opacity === '0') hw.style.opacity = '1';
      hw.classList.toggle('c9-scrolled', sy > 60);
    } else {
      hw.style.opacity = '0';
      hw.style.pointerEvents = 'none';
      hw.classList.add('c9-hidden');
      hw.classList.remove('c9-scrolled');
    }
    if (sticky) sticky.classList.toggle('c9-sticky--visible', pastImg);
  }
  window.addEventListener('scroll', update, { passive: true });
  if (window.scrollY > 0) update();
}

function init() {
  var preload = document.getElementById('c9-preloader');
  if (!preload) {
    killPreloader(); setupHeader();
    document.dispatchEvent(new CustomEvent('clout9:wipe'));
    return;
  }

  /* Brief solid-black hold so the first painted frame is intentional, not a
     flash of half-loaded page. ~220ms — well under the "feels instant" threshold
     for a single visible frame, but long enough to mask layout jank. */
  setTimeout(function() {
    /* Hero columns listen for clout9:wipe — fire it before fading the overlay,
       so the rise animation begins under cover of the black background. */
    document.dispatchEvent(new CustomEvent('clout9:wipe'));

    preload.style.transition = 'opacity 0.55s ease';
    preload.style.opacity = '0';

    setTimeout(function() {
      killPreloader();
      setupHeader();
      document.dispatchEvent(new CustomEvent('clout9:ready'));
    }, 580);
  }, 220);
}

})();
